import React, { Component } from 'react'
import './Accordion.css'

export class Accordion extends Component {
  constructor (props) {
    super()
    this.props = props
    this.state = { isOpen: false }
    this.onOpen = this.props.onOpen
    this.toggle = this.toggle.bind(this)
  }

  toggle () {
    if (this.onOpen && !this.state.isOpen) {
      this.onOpen()
    }
    this.setState({ isOpen: !this.state.isOpen })
  }

  render () {
    return (
      <div className={`${this.props.className} accordion-container ${this.props.isPrimary ? 'primary-accordion' : ''}`}>
        <div className={'accordion-title-and-button'} onClick={this.toggle}>
          <span className="accordion-title">{this.props.title}</span>
          {this.state.isOpen ? <span>&#x2193;</span> : <span>&#x2192;</span>}
        </div>
        {
          this.state.isOpen &&
          <div className="accordion-content">
            {this.props.content && <div className="content">{this.props.content}</div>}
            {this.props.additionalComponent}
          </div>
        }</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/accordion/Accordion.jsx